/*
 * File: CardOptionsWidget.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:53 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 26, 2025 at 2:51 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';

// Components
import { IconButton } from '../IconButton';


/**
 * Styles
 */


export const DropdownContainer = styled.div`
	position: relative;
	margin-right: -9px;
`;

export const DropdownToggle = styled(IconButton)`
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;

	&:hover {
		background-color: ${({ theme }) => theme.neutralButton};
		opacity: 1;
	}
`;

export const OptionsDropdown = styled.div`
	background-color: ${({ theme }) => theme.surfaceBackground};
	box-shadow: ${({ theme }) => theme.surfaceShadow};
	border-radius: 10px;
	overflow: hidden;
	position: absolute;
	right: 0px;
	bottom: 35px;
	min-width: 140px;
	padding: 8px 0px;
	opacity: 0;
	visibility: hidden;
	transform: scale(1.05);
	transition: visibility 0s linear 0.3s, opacity 0.3s 0s, transform 0.3s;
	pointer-events: none;

	&.show {
		opacity: 1;
		visibility: visible;
		transform: scale(1);
		transition: visibility 0s linear 0s, opacity 0.3s 0s, transform 0.3s;
		pointer-events: all;
	}
`;

export const NavigationItem = styled.li`
	padding: 8px 16px;
	height: auto !important;
	display: flex;
	align-items: center;
	cursor: pointer;
	width: 100%;
	position: relative;

	&:hover {
		background-color: ${({ theme }) => theme.neutralButton};
	}
	p {
		flex-grow: 1;
		font-size: 15px;
	}
`;

export const IconContainer = styled.div`
	width: 25px;
	margin-right: 8px;
	position: relative;

	svg {
		font-size: 1rem !important;
		width: 25px !important;
		display: flex !important;
		align-items: center;
		position: relative;
		color: ${({ theme }) => theme.primaryText};
	}
`;
